import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import PaymentModel from "../../models/payment";

export default class PaymentRepository extends BaseRepository {
  static modelClass = PaymentModel;
  modelName = "payment";
}
